import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import linkHttp from './linkHttp';
import linkError from './linkError';
import linkState from './linkState';
import linkAuth from './linkAuth';
import { dataIdFromObject } from './dataIdFromObject';

const cache = new InMemoryCache({
  addTypename: true,
  dataIdFromObject,
});
export const apolloClientFactory = uri =>
  new ApolloClient({
    link: ApolloLink.from([
      linkState(cache),
      linkAuth,
      linkError.concat(linkHttp(uri)),
    ]),
    cache,
    name: 'assignment-frontend',
    version: '1.0',
  });
const apolloClient = apolloClientFactory();
export default apolloClient;
